/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { deleteMenuItemApi } from '../../api/menuItems/menuItemsApi';

export default function DeleteMenuItem({ value, setValue, callFunc }) {
  const deleteRow = async (id) => {
    try {
      const response = await deleteMenuItemApi(id);
    } catch (e) {}
    callFunc();
    setValue({ isOpen: false });
    handleClose();
  };

  const handleClose = () => {
    callFunc();
    setValue({ isOpen: false });
  };

  return (
    <div>
      <Dialog
        open={value?.isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure to delete this Menu?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            cancel
          </Button>
          <Button onClick={() => deleteRow(value.id)}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
